import { render, staticRenderFns } from "./IadeArizaMailDonusu.vue?vue&type=template&id=fd993482&"
import script from "./IadeArizaMailDonusu.vue?vue&type=script&lang=js&"
export * from "./IadeArizaMailDonusu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports